import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  TableContainer,
  Typography,
} from "@mui/material";
import VantageListHead from "../../../component/ListHead/SignalList";
import { Tablecell, applySortFilter, getComparator } from "../../../component/Methods";

const SwapStatus = ({ swapStrategies, tableHeader }) => {
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [hasUnavailableStrategy, setHasUnavailableStrategy] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    const filteredUsers = applySortFilter(
      swapStrategies,
      getComparator(order, orderBy)
    );

    setData(filteredUsers);
    // Check if any strategy is unavailable
    const hasUnavailable = swapStrategies?.some(strategy => !strategy.available);
    setHasUnavailableStrategy(hasUnavailable);
  }, [order, orderBy, swapStrategies]);

  return (
    <>
      {data && data?.length > 0 ? (
        <Box
          sx={{
            border: `100px ${theme.palette.lightGrey.tableHeader}`,
            borderRadius: "4px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          {hasUnavailableStrategy && (
            <Typography
              sx={{
                color: "error.main",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 16px",
                my:1,
                backgroundColor: "rgba(211, 47, 47, 0.08)",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
              }}
            >
              Remove the unavailable strategies to proceed further
            </Typography>
          )}
          <TableContainer style={{ height: "380px" }}>
            <Table
              size="small"
              stickyHeader
              aria-label="a dense table"
              sx={{
                height: "max-content",
              }}
            >
              <VantageListHead
                order={order}
                orderBy={orderBy}
                headLabel={tableHeader}
                noStatus={true}
                customizeFont={12}
                rowCount={data.length}
                onRequestSort={handleRequestSort}
              />

              <TableBody>
                {data?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        background: theme.palette.grey[200],
                        cursor: "pointer",
                      },
                    }}
                  >
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.name}
                    </Tablecell>
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row.available ? "Available" : "Not Available"}
                    </Tablecell>

                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.error}
                    </Tablecell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}
    </>
  );
};

export default SwapStatus;
